var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83691 19.3398C5.20605 19.3398 5.4873 19.1641 5.92676 18.7598L8.41406 16.4746C7.92188 16.0791 7.5 15.4111 7.5 14.0488V7.86133C7.5 5.09277 9.19629 3.43164 11.9648 3.43164H18.293L18.2842 3.15918C18.126 1.41016 16.9658 0.232422 14.874 0.232422H2.65723C0.547852 0.232422 -0.779297 1.46289 -0.779297 3.60742V12.4141C-0.779297 14.5322 0.521484 15.833 2.5957 15.833H4.00195V18.3818C4.00195 18.9619 4.30957 19.3398 4.83691 19.3398ZM19.6465 20.6055C20.1826 20.6055 20.4902 20.2275 20.4902 19.6475V17.0986H21.3955C23.4697 17.0986 24.7705 15.7979 24.7705 13.6797V8.08984C24.7705 5.94531 23.4434 4.71484 21.334 4.71484H12.2285C10.04 4.71484 8.79199 5.93652 8.79199 8.125V13.6797C8.79199 15.8154 10.0488 17.0986 12.2285 17.0986H15.3223L18.5654 20.0254C19.0049 20.4297 19.2773 20.6055 19.6465 20.6055Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlue);
export default __webpack_public_path__ + "static/media/comment_blue.67c315c57213be725f10f65d4bb5d5df.svg";
export { ForwardRef as ReactComponent };